function initContentScrollbar(tableId) {
    const content = document.querySelector('.table_overflow[data-table-id="' + tableId + '"]');
    const nativeBar = document.querySelector('.native-scrollbar[data-table-id="' + tableId + '"]');
    if (!content || !nativeBar) return;

    // už jsme tohle konkrétní contentBox jednou inicializovali → neřešit znovu
    if(window.updateContentScrollbar.get(content)) {
        return;
    }

    const nativeInner = nativeBar.querySelector('.native-scrollbar-inner');

    if (!nativeInner) return;

    let isSyncingFromNative = false;
    let isSyncingFromContent = false;

    function updateNativeWidth() {
        const totalWidth = content.scrollWidth;
        const visibleWidth = content.clientWidth;
        const barWidth = nativeBar.clientWidth;

        if (totalWidth <= visibleWidth) {
            nativeBar.style.display = 'none';
            return;
        } else {
            nativeBar.style.display = '';
        }

        const innerWidth = Math.max(barWidth * (totalWidth / visibleWidth), barWidth + 1);
        nativeInner.style.width = Math.ceil(innerWidth) + 'px';

        syncFromContent();
    }

    function syncFromContent() {
        if (isSyncingFromNative) return;
        isSyncingFromContent = true;
        const ratio = content.scrollLeft / (content.scrollWidth - content.clientWidth || 1);
        nativeBar.scrollLeft = ratio * (nativeInner.clientWidth - nativeBar.clientWidth || 1);
        setTimeout(() => {
            isSyncingFromContent = false;
        }, 0);
    }

    function syncFromNative() {
        if (isSyncingFromContent) return;
        isSyncingFromNative = true;
        const ratio = nativeBar.scrollLeft / (nativeInner.clientWidth - nativeBar.clientWidth || 1);
        content.scrollLeft = ratio * (content.scrollWidth - content.clientWidth || 1);
        setTimeout(() => {
            isSyncingFromNative = false;
        }, 0);
    }

    content.addEventListener('scroll', syncFromContent);
    nativeBar.addEventListener('scroll', syncFromNative);

    new ResizeObserver(updateNativeWidth).observe(content);
    new ResizeObserver(updateNativeWidth).observe(nativeBar);

    new MutationObserver(() => {
        setTimeout(updateNativeWidth, 0);
    }).observe(content, {
        childList: true,
        subtree: true,
    });

    updateNativeWidth();
    window.updateContentScrollbar.set(content, updateNativeWidth);
}

document.addEventListener("DOMContentLoaded", () => {
    window.updateContentScrollbar = new WeakMap();

    function handleTables() {
        const tables = document.querySelectorAll(".table_overflow");
        tables.forEach(table => {
            const tableId = table.dataset.tableId;
            initContentScrollbar(tableId);
        })
    }

    // první inicializace po loadu
    handleTables();

    // watcher na změny DOMu (Vue route, načtení nové stránky atd.)
    const globalObserver = new MutationObserver(() => {
        handleTables();
    });

    globalObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });
});



// WEBPACK FOOTER //
// ./src/assets/js/tables.js